import React, { useRef, useEffect } from 'react';
import './Torso.scss';
import Lottie from 'lottie-react';
import animationData from '../../../../assets/apollo/torso/apollo_torso_blue.json';
// import animationData from '../../../../assets/apollo/torso/apollo_torso.json';

function ApolloTorso({ apolloTorsoRef }) {
  const lottieRef = useRef();
  const torsoRef = useRef();
  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.5) {
              lottieRef.current.goToAndPlay(0);
            }
          }
        });
      },
      { threshold: [0, 0.5] }
    );
    observer.observe(torsoRef.current);
  }, []);
  return (
    <section className="torso torso-apollo" ref={apolloTorsoRef}>
      <h3 className="torso__title torso__title-apollo">
        The upper torso of every spacesuit houses the central components of the suit’s key systems.
      </h3>

      <div className="torso__lower">
        <div className="torso__animation torso__animation-apollo" ref={torsoRef}>
          <Lottie
            lottieRef={lottieRef}
            animationData={animationData}
            autoplay={false}
            loop={false}
          />
        </div>
        <div className="torso__lower__text torso__lower__text-apollo">
          <h6>21</h6>
          <p>Layers of fabric required for each spacesuit</p>
        </div>
      </div>
    </section>
  );
}

export default ApolloTorso;
